import '../../../../BF.Monitor/Resources/Private/JavaScript/Monitor'
